import { render, staticRenderFns } from "./ContractStatusTransition.yaml?vue&type=template&id=8b4e0dda&component"
import script from "./ContractStatusTransition.yaml?vue&type=script&lang=ts&component"
export * from "./ContractStatusTransition.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports